import { render, staticRenderFns } from "./TerminalFragment.vue?vue&type=template&id=2b4b0d56&"
import script from "./TerminalFragment.vue?vue&type=script&lang=js&"
export * from "./TerminalFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports